(ns ui.captions.sample
  "A sample transcript for the style previews and the QA page.")

(def words
  [{:word/text "Captions" :word/start 100 :word/end 520 :word/index 0 :word/emphasis? true}
   {:word/text "that" :word/start 560 :word/end 700 :word/index 1}
   {:word/text "follow" :word/start 720 :word/end 1000 :word/index 2}
   {:word/text "every" :word/start 1050 :word/end 1300 :word/index 3}
   {:word/text "word." :word/start 1320 :word/end 1700 :word/index 4}
   {:word/text "Made" :word/start 2100 :word/end 2350 :word/index 5}
   {:word/text "in" :word/start 2360 :word/end 2450 :word/index 6}
   {:word/text "Storrito." :word/start 2500 :word/end 3000 :word/index 7 :word/emphasis? true}])
